<template>
  <div class="about">
    <h1>Protospiel Bingo</h1>
    <p>Protospiel Bingo is a great interactive experience you can give your guests at Protospiel. All you need to do is get some sponsored prizes, and then print out some Protospiel Bingo sheets.</p>
    <p>You can <a href="/bingo/index.html">access the online Protospiel Bingo Generator here</a>.</p>
    <img src="../assets/bingo.png" class="img-fluid">
  </div>
</template>
